// import logo_yourfairshare from "../../assets/logo_homepage3.svg";
// import logo_yourfairshare from "../../assets/logo_homepage_new_2.svg";
import logo_yourfairshare from "../../assets/logo_azilis.png";
import Navigation from "../../components/Navigation";
import PlatformUserMenu from "./PlatformUserMenu";
import { SimProvider } from "../../app/Company/SimContext";
import YearTab, {
  shouldSyncYearFromUrlForPath,
} from "../../components/YearTab";
import React, { useState, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import { useWindowDimensions } from "../../app/Home/ThirdPage";
import "./index.css";
import LangNav from "../LangNav";
import { createContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LogOut } from "lucide-react";
import { logout } from "../../apis/User";
import dashBird from "../../assets/shapes_svg/dashboards/dash-bird.svg";
import dashCheck from "../../assets/shapes_svg/dashboards/dash-check.svg";
import dashCube from "../../assets/shapes_svg/dashboards/dash-cube.svg";
import dashUser from "../../assets/shapes_svg/dashboards/dash-user.svg";
import navIcon from "../../assets/navigator-icon.png";
import dashBusiness from "../../assets/shapes_svg/dashboards/dash-business.svg";
import NavigatorBackground from "../Navigator/NavigatorBackground";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

export const YearTabContext = createContext();

/** Split "Business dashboard" → top: Business, bottom: dashboard (works with hyphen too). */
function splitDashTabLabel(label) {
  const text = String(label || "").trim();
  if (!text) return { top: "", bottom: "" };

  const hyphen = text.indexOf("-");
  if (hyphen > 0) {
    return {
      top: text.slice(0, hyphen).trim(),
      bottom: text.slice(hyphen + 1).trim(),
    };
  }

  const parts = text.split(/\s+/);
  if (parts.length >= 2) {
    return {
      top: parts.slice(0, -1).join(" "),
      bottom: parts[parts.length - 1],
    };
  }

  return { top: text, bottom: "" };
}

function DashTabLabel({ label }) {
  const { top, bottom } = splitDashTabLabel(label);
  return (
    <span className="platformTopbar__dashTabLabel">
      <span className="platformTopbar__dashTabLabelTop">{top}</span>
      {bottom ? (
        <span className="platformTopbar__dashTabLabelBottom">{bottom}</span>
      ) : null}
    </span>
  );
}

export const Print = ({ content }) => {
  const componentRef = React.useRef(null);

  const onBeforeGetContentResolve = React.useRef(null);

  const [loading, setLoading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called"); // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called"); // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    console.log("`onBeforeGetContent` called"); // tslint:disable-line no-console
    setLoading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setLoading, setText]);

  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "AwesomeFileName",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  React.useEffect(() => {
    if (
      text === "New, Updated Text!" &&
      typeof onBeforeGetContentResolve.current === "function"
    ) {
      onBeforeGetContentResolve.current();
    }
  }, [onBeforeGetContentResolve.current, text]);

  const handleButton = () => {
    console.log(reactToPrintContent());
  };

  return (
    // <div>
    //   {loading && <p className="indicator">onBeforeGetContent: Loading...</p>}
    //   <button onClick={handlePrint}>
    //     Print
    //   </button>

    <Skeleton1 ref={componentRef} content={content} />
    // </div>
  );
};

export const useContainerDimensions = (myRef) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const getDimensions = () => ({
      width: myRef.current.scrollWidth,
      height: myRef.current.scrollHeight,
    });

    const handleResize = () => {
      setDimensions(getDimensions());
    };

    if (myRef.current) {
      setDimensions(getDimensions());
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [myRef]);

  return dimensions;
};

const Skeleton1 = React.forwardRef(({ content }, ref) => {
  const { t } = useTranslation();
  const location = useLocation();
  // Exclude product detail pages (paths like /product/{uuid})
  const isProductDetailPage =
    /^\/product\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
      location.pathname,
    );
  const isCompanyDetailPage =
    /^\/company\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
      location.pathname,
    );
  const navigate = useNavigate();

  const overviewUrl = "/overview";
  const adminDashUrl = "/admin-dash";
  const ARDashUrl = "/ar-dash";
  const navigatorUrl = "/info-navigation";
  const [isOverview, setIsOverview] = useState(false);
  const [isNavigator, setIsNavigator] = useState(false);
  const [isAdminDash, setIsAdminDash] = useState(false);
  const [isARDash, setIsARDash] = useState(false);
  useEffect(() => {
    if (overviewUrl.includes(location.pathname)) {
      setIsOverview(true);
    } else {
      setIsOverview(false);
    }

    if (navigatorUrl.includes(location.pathname)) {
      setIsNavigator(true);
    } else {
      setIsNavigator(false);
    }

    if (adminDashUrl.includes(location.pathname)) {
      setIsAdminDash(true);
    } else {
      setIsAdminDash(false);
    }

    if (ARDashUrl.includes(location.pathname)) {
      setIsARDash(true);
    } else {
      setIsARDash(false);
    }
  }, [location.pathname, overviewUrl]);

  const [year, setYear] = useState("");
  const [yearParent, setYearParent] = useState("");
  const dashFromPath = (pathname, search = "") => {
    if (pathname === "/overview" || pathname.startsWith("/overview/")) {
      const wheel = new URLSearchParams(search).get("wheel");
      if (wheel === "business") return "business";
      if (wheel === "admin") return "admin";
      if (wheel === "ar") return "AR";
      return "user";
    }
    if (pathname.startsWith("/business-dash")) return "business";
    if (pathname.startsWith("/admin-dash")) return "admin";
    if (pathname.startsWith("/ar-dash")) return "AR";
    return "";
  };

  const [chosenDash, setChosenDash] = useState(() =>
    typeof window !== "undefined"
      ? dashFromPath(window.location.pathname, window.location.search)
      : "",
  );

  useEffect(() => {
    const next = dashFromPath(location.pathname, location.search);
    if (next) setChosenDash(next);
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (!shouldSyncYearFromUrlForPath(location.pathname)) return;
    const queryParams = new URLSearchParams(location.search);
    // Only apply when `year` is present on the URL; avoids wiping context when
    // opening /product (catalog) without ?year= — YearTab will set the year from API.
    if (!queryParams.has("year")) return;
    const newYear = queryParams.get("year") || "";
    setYear(newYear);
    setYearParent(newYear);
  }, [location.search, location.pathname]);

  const YearTabContextValue = useMemo(() => yearParent, [yearParent]);

  // const ref = useRef(null)
  const { height: heightWindow, width: widthWindow } = useWindowDimensions();
  // const {width,height} = useContainerDimensions(ref)
  const [height, setHeight] = useState(0);
  useEffect(() => {
    if (!ref.current) return; // wait for the elementRef to be available
    const resizeObserver = new ResizeObserver(() => {
      // Do what you want to do when the size of the element changes
      setHeight(ref?.current?.clientHeight);
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect(); // clean up
  }, []);
  //   useEffect(() => {
  //     const interval = setInterval(() => {
  //         setHeight(ref.current.clientHeight)

  //         // // console.log(ref.current.clientHeight)
  //       }, 1000);

  //       return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  //     }, [])
  // const handleScroll = () => {
  // console.log(ref)
  // }

  const handleChooseAr = () => {
    setChosenDash("AR");
    navigate("/overview?wheel=ar");
  };

  const handleChooseAdminDash = () => {
    setChosenDash("admin");
    navigate("/overview?wheel=admin");
  };

  const handleChooseBusinessDash = (e) => {
    e?.stopPropagation(); // Prevent event bubbling
    setChosenDash("business");
    navigate("/overview?wheel=business");
  };

  const handleChooseDashInfo = () => {
    navigate("/info-navigation");
  };
  return (
    <div
      className={`ambition ${isNavigator ? "ambition--navigator" : ""}`}
      ref={ref}
    >
      {isNavigator && (
        <div className="navigator-global-background">
          <NavigatorBackground />
        </div>
      )}
      <div className="ambition__main w-100 d-flex flex-column">
        <div className="platformTopbar">
          <div className="platformTopbar__row1">
            <Link to="/overview" className="platformTopbar__logoLink">
              <img
                src={logo_yourfairshare}
                alt=""
                className="platformTopbar__logo"
              />
            </Link>
            <div className="platformTopbar__center">
              <nav className="platformTopbar__dashRail" aria-label="Dashboards">
                <div className="platformTopbar__dashTrack" role="tablist">
                  <button
                    type="button"
                    role="tab"
                    aria-selected={chosenDash === "business"}
                    aria-label={t("BUSINESS_DASH")}
                    onClick={handleChooseBusinessDash}
                    className={
                      chosenDash === "business"
                        ? "platformTopbar__dashTab platformTopbar__dashTab--active"
                        : "platformTopbar__dashTab"
                    }
                  >
                    <img src={dashBusiness} alt="" width={16} height={14} />
                    <DashTabLabel label={t("BUSINESS_DASH")} />
                  </button>
                  <button
                    type="button"
                    role="tab"
                    aria-selected={chosenDash === "admin"}
                    aria-label={t("ADMIN_DASH")}
                    onClick={handleChooseAdminDash}
                    className={
                      chosenDash === "admin"
                        ? "platformTopbar__dashTab platformTopbar__dashTab--active"
                        : "platformTopbar__dashTab"
                    }
                  >
                    <img src={dashCheck} alt="" width={16} height={14} />
                    <DashTabLabel label={t("ADMIN_DASH")} />
                  </button>
                  <button
                    type="button"
                    role="tab"
                    aria-selected={chosenDash === "user"}
                    aria-label={t("USER_DASH")}
                    onClick={() => {
                      setChosenDash("user");
                      navigate("/overview");
                    }}
                    className={
                      chosenDash === "user"
                        ? "platformTopbar__dashTab platformTopbar__dashTab--active"
                        : "platformTopbar__dashTab"
                    }
                  >
                    <img src={dashUser} alt="" width={16} height={14} />
                    <DashTabLabel label={t("USER_DASH")} />
                  </button>
                  <button
                    type="button"
                    role="tab"
                    aria-selected={chosenDash === "AR"}
                    aria-label={t("AR_DASH")}
                    onClick={handleChooseAr}
                    className={
                      chosenDash === "AR"
                        ? "platformTopbar__dashTab platformTopbar__dashTab--active"
                        : "platformTopbar__dashTab"
                    }
                  >
                    <img src={dashCube} alt="" width={16} height={14} />
                    <DashTabLabel label={t("AR_DASH")} />
                  </button>
                </div>
              </nav>
              <button
                type="button"
                className="platformTopbar__navBtn"
                onClick={handleChooseDashInfo}
                title="Navigator"
                aria-label="Navigator"
              >
                <img src={navIcon} alt="" width={20} height={20} />
              </button>
            </div>
            <div className="platformTopbar__right">
              <div className="platformTopbar__langWrap">
                <LangNav embedInTopBar />
              </div>
              <PlatformUserMenu />
              <button
                type="button"
                className="platformTopbar__iconBtn"
                onClick={() => logout()}
                aria-label="Log out"
              >
                <LogOut className="h-4 w-4" />
              </button>
            </div>
          </div>
          {!isOverview &&
          !isAdminDash &&
          !isARDash &&
          !isNavigator &&
          !isProductDetailPage &&
          !isCompanyDetailPage ? (
            <div className="platformTopbar__row2">
              <Navigation />
            </div>
          ) : null}
        </div>
        <div
          className={`ambition__main__bottom d-flex flex-column ${isNavigator ? "ambition__main__bottom--navigator" : ""}`}
          style={{ marginTop: isNavigator ? 0 : "2vh" }}
        >
          <SimProvider>
            {isOverview ||
            isAdminDash ||
            isARDash ||
            isNavigator ||
            isProductDetailPage ? (
              <YearTabContext.Provider value={YearTabContextValue}>
                {content}
              </YearTabContext.Provider>
            ) : (
              <>
                <YearTab setYearParent={setYearParent} />
                <YearTabContext.Provider value={YearTabContextValue}>
                  {content}
                </YearTabContext.Provider>
              </>
            )}
          </SimProvider>
        </div>
      </div>
    </div>
  );
});

export const Skeleton = ({ content }) => {
  return <Print content={content} />;
};

export default Skeleton;
